module.exports = __webpack_public_path__ + "img/group-of-men.a838e0ab.png";